import { DynamicForm } from "../../components/DynamicForm";
import Fieldset from "../../components/Fieldset";
import { Button, ButtonGroup, Badge, Col, Form, Row } from "react-bootstrap";
import { ErrorMessage } from "formik";
import { ButtonModel } from "../../models/components/button.model";
import { useEffect, useRef, useState } from "react";
import "./process.css";
import ProcessService from "../../services/process.service";

import CreatableSelect from "react-select/creatable";
import { formatDate } from "../../util/tools";

interface FilterProcessProps {
	buttonsTop: ButtonModel[];
	fieldList: any[];
	fieldList2: any[];
	filterValue: any[];
	editingIndex: number | null;
	editingValue: string;
	handleDelete: (index: number) => void;
	handleEditSubmit: (index: number) => void;
	setEditingIndex: (index: number | null) => void;
	setEditingValue: (val: string) => void;
	getBadgeColor: (item: any) => string;
	getIndentLevel: (arr: any[], index: number) => number;
	handleClearAll: () => void;
	addFilter: (type: string, values: any) => void;
	addParentheses: (paren: "(" | ")") => void;
	reset: () => void;
	questionModal: any;
	setQuestionModal: (val: any) => void;
	handleCheckQuery: () => void;
	handleSubmit: any;
	handleChange: any;
	handleBlur: any;
	touched: any;
	errors: any;
	values: any;
	setFieldValue: any;
	setFilterValue: (value: any[]) => void;
	isLoading: boolean;
	queryList: any[];
	handleChangeQuery: (id:string) => void;
}

export const FilterProcess = ({
	buttonsTop,
	fieldList,
	fieldList2,
	filterValue,
	editingIndex,
	editingValue,
	handleDelete,
	handleEditSubmit,
	setEditingIndex,
	setEditingValue,
	getBadgeColor,
	getIndentLevel,
	handleClearAll,
	addFilter,
	addParentheses,
	reset,
	questionModal,
	setQuestionModal,
	handleCheckQuery,
	handleSubmit,
	handleChange,
	handleBlur,
	touched,
	errors,
	values,
	setFieldValue,
	setFilterValue,
	isLoading,
	queryList,
	handleChangeQuery
}: FilterProcessProps) => {
	const clickTimeout = useRef<NodeJS.Timeout | null>(null);
	const adjustIdName = (text: string) =>
		text?.toLowerCase().replace(/\s/g, "-");

	useEffect(() => {
		const selected = queryList.find(
			(item: any) => item.id === values.values.query
		);
		setFieldValue("values.queryName", selected?.name || "");
	}, [values.values.query, queryList]);


	// 🔥 Atualiza o nome da query automaticamente
	useEffect(() => {
		const selected = fieldList[0]?.optionsList?.find(
			(item: any) => item.id === values.values.query
		);
		setFieldValue("values.queryName", selected?.name || "");
	}, [values.values.query]);

	const handleQueryChange = async (newValue: any) => {

		if (!newValue) {
			setFieldValue("values.queryName", "");
			setFieldValue("values.query", null);
			setFilterValue([]);
			handleClearAll();
			return;
		}

		if (newValue.__isNew__) {
			setFieldValue("values.query", newValue.label);
			handleClearAll();
		} else {
			setFieldValue("values.query", newValue.label);
			setFieldValue("values.tribunal", newValue.value.tribunal);
			setFieldValue("values.numProcesso", newValue.value.numProcesso);
			setFieldValue("values.dtInicio", formatDate(newValue.value.dtInicio));
			setFieldValue("values.dtFim", formatDate(newValue.value.dtFim));
			setFilterValue(JSON.parse(newValue.value.jsonNuvem));
			if(newValue.value.guidQuery){
				handleChangeQuery(newValue.value.guidQuery)
			}
			handleClearAll();
		}

	};

	const handlePressKey = (target: any) => {
		if (target.key === "Enter" || target.keyCode === 13) {
			target.preventDefault();
			if (values.values.description?.trim()) {
				addFilter("and", values);
				setFieldValue("values.description", "");
			}
		}
	};




	return (
		<Fieldset legend="Filtro de Processos">
			<div
				style={{
					display: "flex",
					justifyContent: "flex-end",
					gap: 10,
					marginBottom: 10,
					paddingRight: 10,
				}}
			>
				{buttonsTop
					.map((button: ButtonModel, index: any) => (
						<Button
							id={button.idText ?? "btn-" + adjustIdName(button.text)}
							key={index}
							size="sm"
							variant={button.variant ?? "primary"}
							disabled={button.disabled || (button.idText === "btn-Excluir" && values.values.query === null)}
							onClick={button.onClick}
							className="icon-button"
							title={button.tooltip}
						>
							<div className="div-button">
								<span className="fa-icon-button">{button.icon}</span>{" "}
								{button.text?.length !== 0 && (
									<span className="text-button">{button.text}</span>
								)}
							</div>
						</Button>
					))}
			</div>

			<div className="scroll-container">
				<Col sm={12} style={{ marginBottom: 10 }}>
					<Form.Group className="form-group selected select-floating-label">
						<CreatableSelect
							isClearable
							placeholder=""
							onChange={handleQueryChange}
							options={queryList}
							formatCreateLabel={(inputValue) => `${inputValue} (Adicionar)`}
							value={
								values?.values?.query
									? { label: values.values.query, value: values.values.query }
									: null
							}
							classNamePrefix="react-select"
							noOptionsMessage={({ inputValue }) => 'Nenhum resultado encontrado'}
						/>
						<Form.Label className="form-label">
							Selecione ou digite a Query
						</Form.Label>
					</Form.Group>
				</Col>

				<DynamicForm
					handleKeyPress={(target) => handlePressKey(target)}
					form="values"
					fieldList={fieldList}
					touched={touched}
					errors={errors}
					handleChange={handleChange}
					setFieldValue={setFieldValue}
					handleBlur={handleBlur}
					values={values}
				/>
				<Col sm={12} style={{ marginBottom: 0 }}></Col>

				{/* 🔥 Data Inicial e Final lado a lado */}
				<Row style={{ paddingLeft: "15px", paddingRight: "15px" }}>
					<Col sm={6}>
						<Form.Group>
							<Form.Label>Data Inicial</Form.Label>
							<Form.Control
								type="date"
								id="dtInicio"
								name="values.dtInicio"
								value={values.values.dtInicio || ""}
								onChange={handleChange}
							/>
							<ErrorMessage name="dtInicio" />
						</Form.Group>
					</Col>
					<Col sm={6}>
						<Form.Group>
							<Form.Label>Data Fim</Form.Label>
							<Form.Control
								type="date"
								id="dtFim"
								name="values.dtFim"
								value={values.values.dtFim || ""}
								onChange={handleChange}
							/>
							<ErrorMessage name="dtFim" />
						</Form.Group>
					</Col>
				</Row>

				{/* 🔥 Operadores AND / OR / ( ) */}
				<Row className="query-buttons-group">
					<Col sm={12}>
						<ButtonGroup size="sm" className="me-2">
							<Button onClick={() => addFilter("and", values)}>+ (E)</Button>
							<Button
								variant="secondary"
								onClick={() => addFilter("or", values)}
							>
								+ (OU)
							</Button>
						</ButtonGroup>
						<ButtonGroup size="sm" className="me-2">
							<Button onClick={() => addParentheses("(")}>(</Button>
							<Button variant="secondary" onClick={() => addParentheses(")")}>
								)
							</Button>
						</ButtonGroup>
						<ButtonGroup size="sm" className="me-2">
							<Button
								onClick={() =>
									setQuestionModal({ ...questionModal, show: true })
								}
							>
								<i className="fas fa-rotate-left" />
							</Button>
							<Button variant="secondary" onClick={handleCheckQuery}>
								<i className="fas fa-check" />
							</Button>
						</ButtonGroup>
					</Col>
				</Row>

				<Row
					style={{
						padding: 10,
						paddingTop: "20px",
						paddingLeft: "15px",
						paddingRight: "15px",
					}}
				>
					{/* 🔥 Descrição */}
					<DynamicForm
						handleKeyPress={(target) => handlePressKey(target)}
						form="values"
						fieldList={fieldList2}
						touched={touched}
						errors={errors}
						handleChange={handleChange}
						setFieldValue={setFieldValue}
						handleBlur={handleBlur}
						values={values}
					/>
				</Row>

				{/* 🔥 Consulta montada */}
				<Row className="query-badge-container">
					<div style={{ display: "inline-block", paddingBottom: 20 }} className='div-textarea'>
						{filterValue.map((filValue, index) => (
							<span className="me-2" key={index}>
							{editingIndex === index ? (
                                                        filValue.type === 'condition' ? (
                                                            <Form.Control
                                                                type="text"
                                                                size="sm"
                                                                autoFocus
                                                                value={editingValue}
                                                                onChange={(e) => setEditingValue(e.target.value)}
                                                                onBlur={() => handleEditSubmit(index)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') handleEditSubmit(index);
                                                                    if (e.key === 'Escape') setEditingIndex(null);
                                                                }}
                                                            />
                                                        ) : filValue.type === 'operator' ? (
                                                            <Form.Select
                                                                size="sm"
                                                                value={filValue.value}
                                                                onChange={(e) => {
                                                                    const updated = [...filterValue];
                                                                    updated[index] = {
                                                                        ...filValue,
                                                                        value: e.target.value as 'AND' | 'OR'
                                                                    };
                                                                    setFilterValue(updated);
                                                                }}
                                                                onBlur={() => setEditingIndex(null)}
                                                                autoFocus
                                                            >
                                                                <option value="AND">E</option>
                                                                <option value="OR">OU</option>
                                                            </Form.Select>
                                                        ) : null
                                                    ) : (
								<Badge
									bg={getBadgeColor(filValue)}
									style={{ cursor: "pointer" }}
									onClick={() => {
										if (clickTimeout.current) {
											clearTimeout(clickTimeout.current);
											clickTimeout.current = null;
											handleDelete(index);
										} else {
											clickTimeout.current = setTimeout(() => {
												clickTimeout.current = null;
												if (filValue.type === 'condition' || filValue.type === 'operator') {
													setEditingIndex(index);
													setEditingValue(filValue.value);
												}
											}, 250);
										}
									}}
								>
									{filValue.value === "AND"
										? "E"
										: filValue.value === "OR"
											? "OU"
											: filValue.value}
								</Badge>)}
							</span>
						))}
					</div>
				</Row>
			</div>
		</Fieldset>
	);
};

